/* eslint-disable react/jsx-props-no-spreading */
import classNames from 'classnames';
import PropTypes from 'prop-types';
import React from 'react';

import * as AppPropTypes from '../../lib/PropTypes';
import { getComponentFromName } from '../../lib/utils';

import * as Headers from './index';

const propTypes = {
    type: PropTypes.string,
    page: AppPropTypes.page,
    buttons: PropTypes.node,
    className: PropTypes.string,
};

const defaultProps = {
    type: null,
    page: null,
    buttons: null,
    className: null,
};

const Header = ({ type, page, className, buttons, ...props }) => {
    const { type: pageType = 'page' } = page || {};
    const HeaderComponent = getComponentFromName(Headers, type || pageType, null);
    if (HeaderComponent === null) {
        console.warn('Bad Header type', type); // eslint-disable-line
        return null;
    }
    return (
        <div
            className={classNames([
                {
                    [className]: className !== null,
                },
            ])}
        >
            <HeaderComponent page={page} buttons={buttons} {...props} />
        </div>
    );
};

Header.propTypes = propTypes;
Header.defaultProps = defaultProps;

export default Header;
